export enum SupportedLocale {
  EN_US = 'enUS',
  RO_RO = 'roRO'
}
